"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var OverlayImage = function OverlayImage(_ref) {
  var alt = _ref.alt,
    containerProps = _ref.containerProps,
    objectFit = _ref.objectFit,
    permitToShrink = _ref.permitToShrink,
    src = _ref.src;
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    style: permitToShrink ? {
      flexShrink: 1,
      overflow: 'hidden',
      textAlign: 'center'
    } : {}
  }, containerProps), /*#__PURE__*/_react["default"].createElement("img", {
    alt: alt,
    className: "sb-imageOverlay__img",
    src: src,
    style: {
      objectFit: objectFit
    }
  }));
};
var _default = exports["default"] = OverlayImage;